import CountWidget from './widgets/CountWidget';
import StatWidget from './widgets/StatWidget';
import SoftwareUpdatesWidget from './widgets/SoftwareUpdatesWidget';
import NewsWidget from './widgets/NewsWidget';
import BirthdaysWidget from './widgets/BirthdaysWidget';
import EmployeeChatWidget from './widgets/EmployeeChatWidget';

// Maps a manifest widget to its renderer. Most widgets are generic (rendered by
// kind); bespoke widgets are looked up by id first. The backend manifest is the
// source of truth for which widgets exist and the user's rights to see them.
const byId = {
  softwareUpdates: SoftwareUpdatesWidget,
  news: NewsWidget,
  colleagueBirthdays: BirthdaysWidget,
  employeeChat: EmployeeChatWidget,
};

const byKind = {
  count: CountWidget,
  stat: StatWidget,
};

export function getWidgetComponent(widget) {
  return byId[widget.id] || byKind[widget.kind] || null;
}
